import React, { useState, useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';
import Button from '../Button';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import Modal from '../Modal';
import UserTree from '../admin/UserTree';
import AdminAPI from '../../apis/AdminAPI';

const SearchUser = ({ fullPage = false }) => {
  const [showTree, setShowTree] = useState(false);
  const [code, setCode] = useState('');
  const [information, setInformation] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const searcherRef = useRef();

  const sanitizeCode = (code) => {
    if(typeof code === 'string')
      return code.replace(/[^a-zA-Z0-9]/g, '').trim();
    return '';
  }

  useEffect(() => {
    if (!code || !showTree) return;
    if (loading) return;
    setLoading(true);
    setInformation(undefined);
    const codeSanitized = sanitizeCode(code);
    const unsubscribe = AdminAPI.subscribeToUser(
      codeSanitized,
      (state) => setInformation((prevState) => ({ ...prevState, ...state })),
      (key) => setInformation((state) => ({ ...state, [key]: undefined }))
    );
    return () => unsubscribe();
  }, [code, showTree]);

  const ModalTree = (
    <ModalStyled>
      <Content>
        <SimpleBar style={{ maxHeight: '70vh' }}>
          {showTree && (
            <UserTree
              userId={sanitizeCode(code)}
              userName={information?.name}
              userLastname={information?.lastname}
            />
          )}
        </SimpleBar>
      </Content>
      <ButtonStyled
        secondary
        text='Cerrar'
        onClick={() => {
          setShowTree(false);
          setLoading(false);
          setCode('');
          setInformation(undefined);
          searcherRef.current.focus();
        }}
      />
    </ModalStyled>
  );

  return (
    <Container fullPage={fullPage}>
      {showTree && ModalTree}
      <Wrapper>
        <Title>Consulta el avance de tus alumnos</Title>
        <Searcher
          ref={searcherRef}
          placeholder='Código del alumno'
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <Option>
          <Button primary text='Buscar' onClick={() => setShowTree(true)} />
        </Option>
      </Wrapper>
    </Container>
  );
};

const Container = styled.div`
  ${(props) =>
    props.fullPage
      ? css`
          min-height: 100vh;
        `
      : css`
          margin: auto;
        `}
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
`;

const Wrapper = styled.div`
  margin: auto;
  max-width: 500px;
  width: 100%;
`;

const Title = styled.h3`
  margin-bottom: 20px;
  text-align: center;
  font-weight: normal;
`;

const Searcher = styled.input`
  background-color: #eceff1;
  border-radius: 10px;
  border-width: 0px;
  padding: 15px 25px;
  outline: none;
  box-sizing: border-box;

  width: 100%;
  font-size: 0.8em;
`;

const Option = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const ModalStyled = styled(Modal)`
  max-width: 450px;
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 95%;
`;

const ButtonStyled = styled(Button)`
  margin-top: 10px;
  margin-bottom: 10px;
`;

const Content = styled.div`
  width: 100%;
`;

export default SearchUser;
